import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { PiV2InfoCollapseComponent } from './pi-v2-info-collapse/pi-v2-info-collapse.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { ProjectV2 } from '@app/interfaces';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'mnf-section-information',
  standalone: true,
  imports: [PiV2InfoCollapseComponent, MatExpansionModule, CommonModule],
  templateUrl: './section-information.component.html',
  styleUrls: ['./section-information.component.scss']
})
export class SectionInformationComponent implements OnChanges {
  
  @Input() infoProject: ProjectV2;

  defaultSection = false;
   
  sectionsProject = [
    { id: 1, title: 'Detalles del proyecto', open: false, visible: true },
    { id: 7, title: 'Detalles del financiamiento', open: false, visible: true },
    { id: 0, title: 'Métricas clave', open: false, visible: true },
    //{ id: 2, title: 'Esquema legal', open: false, visible: true },
    { id: 3, title: 'Esquema legal y garantía del financiamiento', open: false, visible: true },
    { id: 4, title: 'Ubicación', open: false, visible: true },
    { id: 5, title: 'Solicitante del financiamiento', open: false, visible: true },
    { id: 6, title: 'Documentos del proyecto', open: false, visible: true },
  ];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.infoProject) {
      this.updateSectionVisibility();
    }
  }

  private updateSectionVisibility(): void {
    if (this.infoProject && this.infoProject.newProject) {
      this.sectionsProject = this.sectionsProject.map(section => {
        if (section.id === 3) {
          section.visible = this.infoProject?.newProject?.sectionInformation?.warranty !== null || this.infoProject?.newProject?.sectionInformation?.schemaLegal !== null;
        } else if (section.id === 7) {
          section.visible =  !!this.infoProject?.newProject?.sectionInformation?.schemaOperation ||  !!this.infoProject?.newProject?.sectionInformation?.schemaDescription;
        }
        return section;
      });
    }
  }

  getOrderedSections(): any[] {
    if (this.infoProject?.actualState === 'fixed'){
      const thirdElement = this.sectionsProject[2];
      const otherElements = this.sectionsProject.filter((_, index) => index !== 2);
      return [thirdElement, ...otherElements];
    } else {
      return this.sectionsProject;
    }
  }
}
